import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import Config from '../../../Config';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../../Shared/Buttons/BtnWhiteBlackBorderBigSize';

const InnerPopupComponent = ({image,text,purpleBtnText,whiteBtnText,isErrorText,setShowPopUp}) => {
  const handleClosePopUp = () => {
    setShowPopUp(false);
  };
  return(
    <div className='inner-popup-container'>
      {image && <Image src={image} className='inner-popup-image' />}
      {text&&<div className={`inner-popup-text ${isErrorText?'error-text':''}`}><span>{text}</span></div>}
      {purpleBtnText&&<BtnSubmit text={purpleBtnText} onclick={()=>handleClosePopUp()}/>}
      {whiteBtnText&&<BtnWhiteBlackBorderBigSize text={whiteBtnText} onclick={()=>handleClosePopUp()}/>}
    </div>
  );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(InnerPopupComponent);
